// Module
var code = `<template>
  <require from="./nokkeltall-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .nokkeltall-widget-\${id} td {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
    }

    .nokkeltall-widget-\${id} th {
      font-family: \${captionFont ? captionFont : 'var(--dyn-default-caption-font-family)'};
      font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-caption-font-size)'};
      color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
    }
  </style>
  <!-- beautify ignore:end -->

  <global-progress if.bind="loading"></global-progress>
  <div if.bind="!loading && !error" class="nokkeltall-widget nokkeltall-widget-\${id}">
    <table>
      <thead>
        <tr>
          <th>Nøkkeltall</th>
          <th class="nokkeltall-widget__numeric">mNOK</th>
          <th class="nokkeltall-widget__numeric">%</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>NAV</td>
          <td class="nokkeltall-widget__numeric">
            \${nav / 1000000 | numericFormatter:'twoDec'}
          </td>
          <td class="nokkeltall-widget__numeric"></td>
        </tr>

        <tr>
          <td>Avkastning i år</td>
          <td class="nokkeltall-widget__numeric">
            \${profitYTD / 1000000 | numericFormatter:'twoDec'}
          </td>
          <td class="nokkeltall-widget__numeric">
            \${profitYTDPercent | numericFormatter:'twoDec'}
          </td>
        </tr>

        <tr>
          <td>Avkastning i perioden</td>
          <td class="nokkeltall-widget__numeric">
            \${profitPeriod / 1000000 | numericFormatter:'twoDec'}
          </td>
          <td class="nokkeltall-widget__numeric">
            \${profitPeriodPercent | numericFormatter:'twoDec'}
          </td>
        </tr>

        <tr>
          <td>Avkastning siden oppstart</td>
          <td class="nokkeltall-widget__numeric">
            \${profitTotal / 1000000 | numericFormatter:'twoDec'}
          </td>
          <td class="nokkeltall-widget__numeric"></td>
        </tr>
      </tbody>

    </table>
  </div>
  <message if.bind="error" icon="error" colour="mdc-theme--error" class="nokkeltall-widget__error">
    \${error.message}</message>
  <div if.bind="noGL" class="nokkeltall-widget-gl-warning warning">
    Warning: No GL data available for this period
  </div>

</template>
`;
// Exports
export default code;